import React from 'react';
import { AppButton, Box } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  modalTitle?: string;
  children?: React.ReactNode;
}

export const TransactionDocumentsPreviewModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  modalTitle,
  children,
}) => (
  <ModalWrapper
    visible={visible}
    title={modalTitle}
    onSetVisible={onSetVisible}
    testId="transaction-documents-preview-Modal-wrapper-id"
    maxWidth="1035px"
  >
    <Box
      width={{
        min: '990px',
      }}
      height={{
        min: '493px',
      }}
      background="module"
      pad={{ top: 'l', horizontal: 'l', bottom: 'm' }}
      round="moduleRound"
      margin={{ bottom: 'l' }}
    >
      {children}
    </Box>

    <Box alignSelf="end">
      <AppButton
        testId="transaction-documents-preview-close-button-id"
        onClick={() => onSetVisible(false)}
        buttonType="secondary"
        width="160px"
      >
        Close
      </AppButton>
    </Box>
  </ModalWrapper>
);
